var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flag/RU"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_698_2022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M0.666016 0.5V15.9166H17.3327V0.5H0.666016Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.666016 0.5H17.3327V15.9168H0.666016V0.5Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.666016 0.5H17.3327V5.63877H0.666016V0.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.666016 10.7773H17.3327V15.9161H0.666016V10.7773Z",
    fill: "#D80027"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 0.766016,
    y: 0.6,
    width: 16.4667,
    height: 15.2167,
    rx: 1.9,
    stroke: "#F1F1F1",
    strokeWidth: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_698_2022"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.666016,
    y: 0.5,
    width: 16.6667,
    height: 15.4167,
    rx: 2,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.7c2efcde2c985b6e85b0d8a56d9d874a.svg";
export { ForwardRef as ReactComponent };